import { render } from "./DetailsExecutives.vue?vue&type=template&id=454fd45f&scoped=true"
import script from "./DetailsExecutives.vue?vue&type=script&lang=js"
export * from "./DetailsExecutives.vue?vue&type=script&lang=js"

import "./DetailsExecutives.vue?vue&type=style&index=0&id=454fd45f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454fd45f"]])

export default __exports__